import script from "./InstructionsListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionsListPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionsListPage.vue?vue&type=style&index=0&id=24243db6&scoped=true&lang=css"

import exportComponent from "F:\\MyCode\\ZSTek.SpecialEquipment\\ZSTek.SE.Screen.Web.Backstage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24243db6"]])

export default __exports__